import { render } from "./GeneralTextArea.vue?vue&type=template&id=7c77ac36&scoped=true&ts=true"
import script from "./GeneralTextArea.vue?vue&type=script&lang=ts"
export * from "./GeneralTextArea.vue?vue&type=script&lang=ts"

import "./GeneralTextArea.vue?vue&type=style&index=0&id=7c77ac36&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c77ac36"]])

export default __exports__